
/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 01, 2017
 * For information or permission request, email info@aetonixsystems.com
 */

import PropTypes from "prop-types";
import React from "react";
import {
	TouchableOpacity,
	StyleSheet,
	View,
} from "react-native";
import noop from "noop3";
import Style from "@aetonix/styles";

import StyledText from "./StyledText";
import StyledIcon from "./StyledIcon";
import TouchableDebounce from "./TouchableDebounce";
import TouchableThrottle from "./TouchableThrottle";

var styles = StyleSheet.create({
	contrastBackground: {
		backgroundColor: Style.look.contrast.sectionBackground,
	},
	lightBackground: {
		backgroundColor: Style.look.sectionBackground,
	},
	secondaryBackground: {
		backgroundColor: Style.look.secondaryBackground,
	},
	alertBackground: {
		backgroundColor: Style.look.alert,
	},
	whiteBackground: {
		backgroundColor: Style.colors.white,
	},
	aligned: {
		alignSelf: "baseline",
	},
	buttonContent: {
		flexDirection: "row",
	},
	buttonIconPadding: {
		marginRight: Style.layout.marginSmall
	},
	aTouchAwayIcon:{
		color: '#51A0A4'
	},
	disabled: {
		opacity: Style.look.disabled,
	},
	padded: {
		padding: Style.layout.paddingButton,
	},
	paddedSmall: {
		padding: Style.layout.paddingSmall,
	},
	border: {
		borderWidth: 1,
		borderColor: Style.colors.primary
	},
	iconAndText: {
		flexDirection: "row",
		alignItems: "center"
	},
	stretch: {
		alignSelf: "stretch",
	},
	centered: {
		alignItems: "center"
	}
});

export default function StyledButton(props, context){
	var onPress = props.onPress;
	var title = props.title || "";

	var contrast = props.contrast;
	var secondary = props.secondary;
	var clear = props.clear;
	var disabled = props.disabled || false;
	var alert = props.alert;
	var white = props.white;
	var fullwidth = props.fullwidth;
	var border = props.border;
	var tertiary = props.tertiary;
	var aTouchAway = props.aTouchAway;
	var textStyle = props.textStyle;
	var otherStyles = props.style;
	var stretch = props.stretch;
	var centered = props.centered;
	var padded = props.padded;
	var paddedSmall = props.paddedSmall;
	var id = props.id;

	var styleList = [styles.buttonContent, styles.padded, styles.lightBackground];
	var containerStyle = [styles.iconAndText];
	var isContrastText = !!contrast;

	var sizes = Style.text;
	var sizeNames = Object.keys(sizes);
	var secondaryText = false;

	if(clear){
		styleList = [];
		if(!tertiary)
			secondaryText = !secondary;
	} else if(white) {
		styleList = [styles.padded, styles.whiteBackground];
	} else	if(contrast){
		styleList = [styles.padded, styles.contrastBackground];
	} else if(secondary){
		isContrastText = true;
		styleList = [styles.padded, styles.secondaryBackground];
	} else if(alert){
		isContrastText = true;
		styleList = [styles.padded, styles.alertBackground];
	}

	if(!fullwidth)
		styleList.push(styles.aligned);

	if(border)
		styleList.push(styles.border);

	if(disabled){
		onPress = noop;
		containerStyle.push(styles.disabled);
	}

	if(stretch){
		styleList.push(styles.stretch);
	}

	if(centered){
		styleList.push(styles.centered);
	}

	if(padded){
		styleList.push(styles.padded);
	}

	if (paddedSmall){
		styleList.push(styles.paddedSmall);
	}

	if (otherStyles) styleList.push(otherStyles);

	var titleSize = sizeNames.reduce(function(found, name){
		if(found) return found;
		if(props[name]) return name;
		return null;
	}, null) || "standard";

	var sizeProps = {};
	sizeProps[titleSize] = true;

	var iconName = props.icon;
	var icon = null;
	var iconStyles = [];
	if(iconName){
		if(title){
			iconStyles.push(styles.buttonIconPadding);
		}if(aTouchAway){
			iconStyles.push(styles.aTouchAwayIcon);
		}
		icon = (
			<StyledIcon style={iconStyles} name={iconName} alert={alert} contrast={isContrastText} tertiary={tertiary} {...sizeProps} />
		);
	}

	var children = props.children;
	if(children) {
		icon = children;
	}

	var Touchable = TouchableOpacity;
	if(props.delayClicks)
		Touchable = TouchableDebounce;
	else if(props.throttleClicks)
		Touchable = TouchableThrottle;

	// Wrap in a view to fix display bugs
	return (
		<View style={props.wrapperViewStyle}>
			<Touchable id={context.id_prefix + id} accessibilityComponentType="button" style={styleList} onPress={onPress} disabled={disabled} delayClicks={props.delayClick} throttleClicks={props.throttleClicks}>
				<View style={containerStyle}>
					{icon}
					<StyledText
						id={id + "_text"}
						style={textStyle}
						compact
						inline
						alert={alert}
						secondary={secondaryText}
						contrast={isContrastText}
						tertiary={tertiary}
						{...sizeProps}>
						{title}
					</StyledText>
				</View>
			</Touchable>
		</View>
	);
}

StyledButton.contextTypes = {
	id_prefix: PropTypes.string
};
